export const screenName = 'Task Success';
export const events = Object.freeze({
    mainAction: 'Task Success - Add Another'
});

export const metrics = Object.freeze({
    screenName,
    events
});
